import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { brl } from "@/lib/api";

export const newQuoteItem = () => ({ key: `${Date.now()}-${Math.random()}`, description: "", unit: "un", quantity: "", unit_price: "", total: "" });

const Cell = ({ label, className = "", children }) => (
  <label className={`space-y-1 ${className}`}>
    <span className="block text-[11px] font-semibold uppercase tracking-wider text-slate-500">{label}</span>
    {children}
  </label>
);

function ItemRow({ item, i, onChange, onRemove, canRemove }) {
  const set = (k) => (e) => onChange({ ...item, [k]: e.target.value });
  return (
    <div className="grid grid-cols-2 gap-3 rounded-md border border-slate-200 bg-slate-50/60 p-3 sm:grid-cols-12" data-testid={`quote-item-${i}`}>
      <Cell label="Produto / serviço" className="col-span-2 sm:col-span-4">
        <Input required maxLength={300} value={item.description} onChange={set("description")} placeholder="Ex.: PVC expandido de 10mm" data-testid={`input-quote-desc-${i}`} />
      </Cell>
      <Cell label="Vendido por" className="sm:col-span-2">
        <select value={item.unit} onChange={set("unit")} className="h-10 w-full rounded-md border border-input bg-white px-2 text-sm" data-testid={`select-quote-unit-${i}`}>
          <option value="un">Unidade</option>
          <option value="m2">Metro² (m²)</option>
        </select>
      </Cell>
      <Cell label={item.unit === "m2" ? "Qtd. (m²)" : "Qtd."} className="sm:col-span-2">
        <Input required type="number" step="0.01" min="0.01" value={item.quantity} onChange={set("quantity")} className="font-mono" data-testid={`input-quote-qty-${i}`} />
      </Cell>
      <Cell label="Valor unit. (R$)" className="sm:col-span-2">
        <Input type="number" step="0.01" min="0" value={item.unit_price} onChange={set("unit_price")} className="font-mono" data-testid={`input-quote-unit-price-${i}`} />
      </Cell>
      <Cell label="Total (R$)" className="sm:col-span-2">
        <div className="flex gap-1">
          <Input required type="number" step="0.01" min="0" value={item.total} onChange={set("total")} className="font-mono" data-testid={`input-quote-total-${i}`} />
          {canRemove && <Button type="button" variant="ghost" size="icon" onClick={onRemove} aria-label="Remover item" data-testid={`btn-remove-quote-item-${i}`}><Trash2 className="h-4 w-4 text-red-500" /></Button>}
        </div>
      </Cell>
    </div>
  );
}

export function QuoteItems({ items, onChange }) {
  const total = items.reduce((s, it) => s + (Number(it.total) || 0), 0);
  const update = (i, v) => onChange(items.map((it, j) => (j === i ? v : it)));
  return (
    <div className="space-y-3">
      {items.map((it, i) => (
        <ItemRow key={it.key} item={it} i={i} onChange={(v) => update(i, v)} onRemove={() => onChange(items.filter((_, j) => j !== i))} canRemove={items.length > 1} />
      ))}
      <div className="flex flex-wrap items-center justify-between gap-3">
        <Button type="button" variant="outline" onClick={() => onChange([...items, newQuoteItem()])} className="rounded-full" data-testid="btn-add-quote-item"><Plus className="h-4 w-4" /> Adicionar item</Button>
        <p className="text-sm text-slate-500">Total do orçamento <span className="ml-2 font-mono text-xl font-bold text-slate-900" data-testid="quote-total">{brl(total)}</span></p>
      </div>
    </div>
  );
}
